<template>
    <div>
        <page-header title="Indstillinger" />
        <div class="tabs">
            <ul>
                <router-link :to="{ path: '/settings/profile' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Profil</a></li>
                </router-link>
                <router-link v-if="$store.getters.user.role === 'admin'" :to="{ path: '/settings/users' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Brugere</a></li>
                </router-link>
                <router-link :to="{ path: '/settings/projects' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Sager</a></li>
                </router-link>
                <router-link v-if="$store.getters.user.role === 'admin'" :to="{ path: '/settings/integrations' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Integrationer</a></li>
                </router-link>
                <router-link v-if="$store.getters.user.role === 'admin'" :to="{ path: '/settings/pdf' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>PDF</a></li>
                </router-link>
                <router-link v-if="$store.getters.user.role === 'admin'" :to="{ path: '/settings/invoicing' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Fakturering</a></li>
                </router-link>
                <router-link v-if="$store.getters.user.role === 'admin' && $inventoryEnabled" :to="{ path: '/settings/inventory' }" custom v-slot="{ navigate }">
                    <li @click="navigate" role="link"><a>Lager</a></li>
                </router-link>
            </ul>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import PageHeader from '@elems/pageHeader'
export default {
    components: {
        PageHeader,
    }
}
</script>
